import React, { ChangeEvent, FC, useEffect, useState } from "react";
import "./Dashboard.css";
import TopSlider from "../TopSlider/TopSlider";
import Logout from "../Logout/Logout";
import ReactQuill from "react-quill";
import {
  admission,
  ArticleCategory,
  college,
  CollegeWebsiteAdderDAO,
  ContentType,
  course,
  educationCategory,
  state,
  State,
  techCategory,
} from "../../interfaces";
import { apiGet, apiPost, apiPostWithFile } from "../../api/apiActions";
import { getToken, removeSessionToken } from "../../store/sessionManager";
import { useNavigate } from "react-router-dom";
import { Country as ctry } from "../../interfaces";
import axios from "axios";
import { API_URL } from "../../constants/urls";

interface DashboardProps {}

interface YoutubeChannelDetail {
  id: Number;
  userId: string;
  name: string;
  channelId: string;
  enabled: boolean; // New enabled flag
  thumbnail: string;
  channelName: string;
  subscriberCount: string;
}

const Dashboard: FC<DashboardProps> = () => {
  const [showAddArticle, setShowAddArticle] = useState<boolean>(false);
  const [showAddWebsite, setShowAddWebsite] = useState<boolean>(false);
  const [collegeId, setCollegeId] = useState("0");
  const [value, setValue] = useState("");
  const [title, setTitle] = useState("");
  const [youtubeUrl, steYoutubeUrl] = useState("");
  const [tags, setTags] = useState("");
  const [error, setError] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [pageId, setPageId] = useState("");
  const [countries, setCountries] = useState<ctry[]>();
  const [states, setStates] = useState<State[]>();
  const [admissions, setAdmissions] = useState<admission[]>();
  const [colleges, setColleges] = useState<college[]>();
  const [collegeWebsite, setCollegeWebsite] =
    useState<CollegeWebsiteAdderDAO>();
  const [courses, setCourses] = useState<course[]>();
  const [contentTypes, setContentTypess] = useState<ContentType[]>();
  const [educationCategories, setEducationCategories] =
    useState<educationCategory[]>();
  const [techCategories, setTechCategories] = useState<techCategory[]>();

  const [imageName, setImageName] = useState("");
  const reader = new FileReader();

  const [articleCategories, setArticleCategories] =
    useState<ArticleCategory[]>();
  const navigate = useNavigate();

  async function handleDeleteCrumb() {
    //let url = `/apis/education-data/article-category`;
    //const response = await apiGet(url);

    axios
      .get(url + `apis/nuhman/tech/categories?show=5`)
      .then((res) => {
        setTechCategories(res?.data);
      })
      .catch((err) => console.log(err));

    // if (response?.status === 401) {
    //   //place your reentry code
    //   removeSessionToken();
    //   navigate("/login");
    // } else {
    //   setArticleCategories(response?.data);
    // }
  }

  useEffect(() => {
    if (getToken() == null) {
      removeSessionToken();
      navigate("/login");
    }
    handleDeleteCrumb();
  }, []);

  const module = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const url = API_URL;
  function addArticleBox(event: React.MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();
    setShowAddArticle(true);
  }

  async function postArticle(formData: FormData) {
    const response = await apiPost("/apis/nuhman/articles", formData);
    if (response?.status === 401) {
      //   //place your reentry code
      removeSessionToken();
      navigate("/login");
    } else {
      setArticleCategories(response?.data);
    }
  }

  async function postArticleImage(
    formData: FormData,
    width: number,
    height: number
  ) {
    const response = await apiPostWithFile(
      "/apis/education-data/article/image?width=" + width + "&height=" + height,
      formData
    );
    setImageName(response?.data);
  }

  function submitArticle(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    formData.set("description", value);
    //formData.set("image", "a" + imageName + ".JPEG");
    //formData.set("image500x280", "b" + imageName + ".JPEG");
    //formData.set("image100x100", "c" + imageName + ".JPEG");

    const response = postArticle(formData);
    //throw new Error("Function not implemented.");
    event.currentTarget.reset();
  }

  function handleFileChange(event: ChangeEvent<HTMLInputElement>): void {
    const filesList = event.target.files;
    if (filesList && filesList.length > 0) {
      reader.readAsDataURL(filesList[0]);
      reader.onload = (e) => {
        const image = new Image();
        image.src = e?.target?.result as string;
        image.onload = () => {
          const { height, width } = image;
          console.log(height + "   ----  " + width);
          const formData = new FormData();
          formData.append("file", filesList[0]);
          const response = postArticleImage(formData, width, height);
        };
      };
    }
  }

  return (
    <>
      <TopSlider />

      <div className="container">
        <div className="row aright">
          <Logout />
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="bg-light rresultser">
              <div className="mb-3 rresult">
                <div className="d-flex align-items-center justify-content-between bg-light py-2 px-4 mb-3">
                  <h2>Test</h2>
                  <span>
                    <a href="#" onClick={addArticleBox}>
                      Add Article
                    </a>
                  </span>
                  <p>
                    <a href="/#/article-manager">Article Manager</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 mmargin">
            <div className="bg-light rresults">
              <div className="mb-3 rresult">
                <div className=" bg-light">
                  {showAddArticle && (
                    <>
                      <div>
                        <h3>Add Article</h3>

                        <form onSubmit={submitArticle}>
                          <div className="control-group wid">
                            <p>
                              Select Article Category:{" "}
                              <select name="articleCategoryId" className=" p-2">
                                <option value={0}>Select</option>
                                {techCategories?.map(
                                  (ctry: techCategory, index) => (
                                    <option key={index} value={ctry.id}>
                                      {ctry.name}
                                    </option>
                                  )
                                )}
                              </select>
                            </p>
                          </div>

                          <div className="control-group wid">
                            <input
                              type="text"
                              className="form-control p-4"
                              id="title"
                              placeholder="Title"
                              onChange={(e) => setTitle(e.target.value)}
                              value={title}
                              name="title"
                              required
                              data-validation-required-message="Please enter a title"
                            />
                            <p className="help-block text-danger"></p>
                          </div>
                          <div className="control-group wid">
                            <input
                              type="text"
                              className="form-control p-4"
                              id="tags"
                              placeholder="Tags"
                              name="tags"
                              onChange={(e) => setTags(e.target.value)}
                              value={tags}
                            />
                            <p className="help-block text-danger">{error}</p>
                          </div>

                          <div className="control-group wid">
                            <p>
                              {" "}
                              Image;
                              <input
                                id="file3"
                                type="file"
                                name="image"
                                onChange={handleFileChange}
                              />
                            </p>
                            <p className="help-block text-danger">
                              {imageName && (
                                <>
                                  <img
                                    src={
                                      "https://nuhman.com/images/c" +
                                      imageName +
                                      ".JPEG"
                                    }
                                    width={100}
                                    height={100}
                                  />
                                </>
                              )}
                            </p>
                          </div>

                          <div className="control-group wid txarea">
                            {" "}
                            <ReactQuill
                              theme="snow"
                              value={value}
                              modules={module}
                              onChange={setValue}
                            />
                          </div>

                          <div className="control-group wid">
                            <input
                              type="text"
                              className="form-control p-4"
                              id="youtubeUrl"
                              placeholder="Youtube Url"
                              onChange={(e) => steYoutubeUrl(e.target.value)}
                              value={youtubeUrl}
                              name="youtubeUrl"
                              data-validation-required-message="Youtube Url"
                            />
                            <p className="help-block text-danger"></p>
                          </div>
                          <div>
                            <button
                              className="btn btn-primary font-weight-semi-bold px-4"
                              style={{ height: 50 }}
                              type="submit"
                              id="sendMessageButton"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
